export default __webpack_public_path__ + "static/media/DNo.26-0.6379d658.jpg";